import i18n from '@/i18n';

export default [
  {
    path: '/scheduled-threads',
    name: 'scheduled-threads',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'schedule-thread',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('scheduled_threads')
    },
    component: () => import('../../views/scheduledThreads/Index'),
  },
  {
    path: '/scheduled-threads/today',
    name: 'scheduled-threads-today',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'schedule-thread',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('todays_scheduled_threads')
    },
    component: () => import('../../views/scheduledThreads/Index'),
  },
];
